export const A2_ESTIMATE_WORKFLOW_ID = 'a200000000000001';
export const PENDING_WORKFLOW_ID = 'a200000000000000';
export const A1_CONSTRUCTION_WORKFLOW_ID = 'a100000000000001';
export const A1_EXECUTION_WORKFLOW_ID = 'a100000000000002';
export const B_CONSTRUCTION_WORKFLOW_ID = 'b100000000000001';
const A2_ROOTS = new Set(['A.案前資料', 'B.建照資料']);
const A1_ROOTS = new Set(['C.施工圖']);
const B_ROOTS = new Set(['D.施工管理']);

export function workflowFolderRestriction(workflowId) {
  if (workflowId === A2_ESTIMATE_WORKFLOW_ID) return '請選擇專案下的 A.案前資料、B.建照資料或其子目錄';
  if (workflowId === A1_CONSTRUCTION_WORKFLOW_ID) return '請選擇專案下的 C.施工圖或其子目錄';
  if (workflowId === B_CONSTRUCTION_WORKFLOW_ID) return '請選擇專案下的 D.施工管理或其子目錄';
  return '';
}

export function allowsWorkflowFolder(workflowId, projectId, folderId, folders) {
  const roots = workflowId === A2_ESTIMATE_WORKFLOW_ID ? A2_ROOTS : workflowId === A1_CONSTRUCTION_WORKFLOW_ID ? A1_ROOTS : workflowId === B_CONSTRUCTION_WORKFLOW_ID ? B_ROOTS : null;
  if (!roots) return true;
  const byId = new Map([...folders].map(folder => [folder.id, folder]));
  let folder = byId.get(folderId);
  const seen = new Set();
  while (folder && folder.projectId === projectId && !seen.has(folder.id)) {
    seen.add(folder.id);
    if (!folder.parentId) return roots.has(folder.name);
    folder = byId.get(folder.parentId);
  }
  return false;
}
